import { useState } from 'react';
import { useAxios } from '../../utils/hook/useAxios';

const REASONS = [
  { value: 'contenu_inapproprie', label: 'Contenu inapproprié' },
  { value: 'informations_fausses', label: 'Informations fausses ou trompeuses' },
  { value: 'prix_abusif', label: 'Prix abusif' },
  { value: 'fraude', label: 'Suspicion de fraude' },
  { value: 'autre', label: 'Autre raison' },
];

function ReportAnnonceForm({ annonceId }) {
  const axios = useAxios();
  const [reason, setReason] = useState('');
  const [details, setDetails] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!reason) return setError('Veuillez choisir une raison.');
    setLoading(true);
    setError(null);
    try {
      await axios.post('/annonce-reports', { annonceId, reason, details });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || "Erreur lors de l'envoi du signalement.");
    }
    setLoading(false);
  };

  if (sent) {
    return (
      <div className="modal-body text-center py-4">
        <i
          className="bi bi-check-circle-fill text-success d-block mb-2"
          style={{ fontSize: 40 }}
        ></i>
        <p className="fw-semibold mb-1">Signalement envoyé</p>
        <p className="text-muted small">
          Notre équipe examinera votre signalement dans les plus brefs délais.
        </p>
        <button className="btn btn-outline-secondary btn-sm mt-2" data-bs-dismiss="modal">
          Fermer
        </button>
      </div>
    );
  }

  return (
    <div className="modal-body">
      <p className="text-muted small mb-3">
        Signalez tout contenu qui vous semble problématique. Votre signalement restera anonyme.
      </p>

      <div className="mb-3">
        <label className="form-label small fw-semibold">Raison du signalement</label>
        {REASONS.map(({ value, label }) => (
          <div key={value} className="form-check">
            <input
              type="radio"
              className="form-check-input"
              id={`reason_${value}`}
              name="reportReason"
              value={value}
              checked={reason === value}
              onChange={() => setReason(value)}
            />
            <label className="form-check-label small" htmlFor={`reason_${value}`}>
              {label}
            </label>
          </div>
        ))}
      </div>

      <div className="mb-3">
        <label className="form-label small fw-semibold">Détails (optionnel)</label>
        <textarea
          className="form-control"
          rows={3}
          placeholder="Décrivez le problème..."
          value={details}
          onChange={(e) => setDetails(e.target.value)}
        />
      </div>

      {error && <div className="alert alert-danger py-2 small">{error}</div>}

      <div className="d-flex gap-2">
        <button className="btn btn-outline-secondary flex-fill btn-sm" data-bs-dismiss="modal">
          Annuler
        </button>
        <button
          className="btn btn-danger flex-fill btn-sm"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? (
            <span className="spinner-border spinner-border-sm me-1"></span>
          ) : (
            <i className="bi bi-flag me-1"></i>
          )}
          Envoyer le signalement
        </button>
      </div>
    </div>
  );
}

export default ReportAnnonceForm;
